// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';

export interface LocalStorageStateProps {
  pollingEnabled?: boolean;
  webSocketEnabled?: boolean;
  isDark?: boolean;
}

export interface LocalStorageContextProps {
  localStorageState: LocalStorageStateProps;
  setLocalStorageState: (key: string, val: string) => void;
  clearWsKeysFromLocalStorageState: () => void;
}

export const LocalStorageContext = React.createContext({} as LocalStorageContextProps);

export const useLocalStorage = () => {
  return React.useContext(LocalStorageContext);
};
